import { type ReactNode } from 'react';
import { ProfileSection, ProfileField } from './profile-section';

type Props = {
  firstName: string;
  lastName: string;
  email: string;
  birthdate: string;
};

const ID_HINT =
  'Tu identidad solo puede modificarla un admin. Si hay un error, contacta soporte.';
const VAL_CLS =
  'rounded-lg border border-border-subtle bg-white/[0.02] px-md py-sm text-sm text-text-secondary';

function ReadValue({
  value,
  fallback,
}: {
  value: string;
  fallback: string;
}): ReactNode {
  return (
    <p className={VAL_CLS}>
      {value || <span className="italic text-text-tertiary">{fallback}</span>}
    </p>
  );
}

const MONTHS = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

function fmtBirthdate(raw: string): string {
  if (!raw) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (!m || !m[1] || !m[2] || !m[3]) return raw;
  const month = MONTHS[parseInt(m[2], 10) - 1] ?? m[2];
  return `${parseInt(m[3], 10)} de ${month} de ${m[1]}`;
}

export function PersonalSection(p: Props): ReactNode {
  return (
    <ProfileSection title="Datos personales" description={ID_HINT}>
      <div className="grid gap-base sm:grid-cols-2">
        <ProfileField label="Nombre">
          <ReadValue value={p.firstName} fallback="Sin nombre" />
        </ProfileField>
        <ProfileField label="Apellidos">
          <ReadValue value={p.lastName} fallback="Sin apellidos" />
        </ProfileField>
      </div>
      <ProfileField label="Email">
        <ReadValue value={p.email} fallback="—" />
      </ProfileField>
      <ProfileField label="Fecha de nacimiento">
        <ReadValue value={fmtBirthdate(p.birthdate)} fallback="No registrada" />
      </ProfileField>
    </ProfileSection>
  );
}
